import { Router } from "@angular/router";
import { ToastrService } from 'ngx-toastr';
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest } from "@angular/common/http";
import { Observable, catchError, throwError } from "rxjs";
import { inject } from "@angular/core";
import { onError } from "@apollo/client/link/error";
import { AuthManager } from "@infra-adapters/services/auth.service";


export const graphqlErrorInterceptor = (
  toastrAlertService: ToastrService,
  router: Router
) => {
  return onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, extensions, locations, path }) => {
        const errorMessage = message || 'Error desconocido en la consulta GraphQL';
        console.log("Error GraphQL:", errorMessage);
        console.log("Detalles del error:", { extensions, locations, path });
        toastrAlertService.error(`Error en la solicitud: ${errorMessage}`);
        if (extensions?.['code'] === 'UNAUTHENTICATED') {
          const currentUrl = router.url;
          router.navigate(['/login'], { queryParams: { returnUrl: currentUrl } });
        }
      });
    }
  
    if (networkError) {
      console.error('Error de red:', networkError);
      toastrAlertService.error('Error de conexión. Verifique su conexión a internet e intente nuevamente.');
    }
  });
}


export const httpAuthErrorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
): Observable<HttpEvent<any>> => {
  const authService = inject(AuthManager);
  const toastAlertService = inject(ToastrService);
  const router = inject(Router);

  const validateExceptionMessage = (message: string) => {
    return message;
  };

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      console.log(error);
      const errorMessage =
        error.error?.message ??
        validateExceptionMessage(error.error?.error) ??
        'Error desconocido en la solicitud HTTP';

      toastAlertService.error(`Error en la solicitud: ${errorMessage}`);

      if (error.status === 401) {
        const currentUrl = router.url;
        authService.cleanSession();
        router.navigate(['/login'], { queryParams: { returnUrl: currentUrl } });
      }
      return throwError(() => error);
    })
  );
};
